module.exports = __webpack_public_path__ + "static/media/general-charm.77162ab8.png";